import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { filter, switchMap } from 'rxjs/operators';
import { DialogService } from 'src/app/common/dialog/dialog.service';
import { ToastService } from 'src/app/common/service/toast.service';
import { LineDirectionCountersResetsDto } from '../../line-direction-counters-reset.dto';
import { LineDirectionCountersResetsService } from '../../line-direction-counters-reset.service';

@Component({
  selector: 'app-line-direction-counters-resets-list',
  templateUrl: './line-direction-counters-resets-list.component.html',
  styleUrls: ['./line-direction-counters-resets-list.component.scss']
})
export class LineDirectionCountersResetsListComponent {
  data: LineDirectionCountersResetsDto[] = [];
  filteredData: LineDirectionCountersResetsDto[] = [];
  loading: boolean = false;
  lastSearched: { carrier: string | null; line: string | null } | null = null;

  readonly form = new FormGroup({
    carrier: new FormControl(null, Validators.required),
    line: new FormControl(null)
  });

  constructor(private resetService: LineDirectionCountersResetsService, private toast: ToastService,
    private dialogService: DialogService, private router: Router) { }

  onSubmit(): void {
    const formValue = this.form.value;
    const carrierChanged = formValue.carrier !== this.lastSearched?.carrier;

    if (carrierChanged) {
      this.loading = true;
      this.resetService.getByCarrier(formValue.carrier).subscribe((v) => {
        this.data = v;
        this.applyLineFilter(formValue.line);
        this.loading = false;
      });
    } else {
      this.applyLineFilter(formValue.line);
    }

    this.lastSearched = { carrier: formValue.carrier, line: formValue.line };
  }

  private applyLineFilter(line: string | null): void {
    this.filteredData = line
      ? this.data.filter((item) => item.line === line)
      : this.data;
  }

  get hasChanged(): boolean {
    return (
      this.form.value.carrier !== this.lastSearched?.carrier ||
      this.form.value.line !== this.lastSearched?.line
    );
  }

  handleFormClear(): void {
    this.lastSearched = null;
    this.data = [];
    this.filteredData = [];
    this.form.reset();
  }

  onDelete(row: LineDirectionCountersResetsDto): void {
    const dialog = this.dialogService.openConfirmationDialog(
      'line-direction-counters-resets.delete-reset-stop-query',
      'line-direction-counters-resets.variant',
      'yes',
      'no',
      false,
      { line: row.line, direction: row.direction }
    );
    dialog.afterClosed()
      .pipe(
        filter(v => v === true),
        switchMap(() => this.resetService.delete(row.getVersionedId()))
      )
      .subscribe(() => {
        this.toast.showWarnToast(
          'line-direction-counters-resets.variant',
          'line-direction-counters-resets.reset-stop-removed',
          { line: row.line, direction: row.direction }
        );
        this.data = this.data.filter(r => r.id !== row.id);
        this.filteredData = this.filteredData.filter(r => r.id !== row.id);
      }, err => {
        console.error(err);
        this.toast.showErrorToast('line-direction-counters-resets.delete-server-error');
      });
  }

}
